import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import router from './router'
import {api} from "./services/api";
import createPersistedState from "vuex-persistedstate";
import localforage from 'localforage';
import LZString from 'lz-string';
//import * as Cookies from "js-cookie";

Vue.use(Vuex)
const getDefaultState = () => {
  return {
    debounceCode:'',
    debouncing:false,
    orderTypeId: '',
    orderingEnd:'',
    tableOccupyEnd:'',
    mobileNumber: '',
    orderRemark:'',
    customerName: '',
    locale: 'jp',
    landingMessageRead:false,
    en:{
      takeAway:'Take Away',
      menu:'Menu',
      orderHistory:'Order History',
      contact:'Contact Us',
      submitOrder:'Submit Order',
      tableNumber:'Table',
      optionTags:'Custom Options',
      setTags:'Custom Set',
      items:'Items',
      soldOut:'Sold out',
      // Additional UI text
      cart:'Cart',
      addToCart:'Add to Cart',
      goBack:'Go Back',
      welcome:'Welcome',
      latestOffers:'Latest Offers',
      free:'Free',
      quantity:'Quantity',
      total:'Total',
      checkout:'Checkout',
      emptyCart:'Your cart is empty',
      close:'Close',
      confirm:'Confirm',
      cancel:'Cancel',
      selectMinimum:'Please select at least {{count}} items',
      orderCompleted:'Your order has been submitted',
      pleaseWait:'Please wait patiently',
      orderCheckedOut:'Order has been checked out, hope to serve you again',
      networkError:'Network connection problem occurred',
      confirmWithStaff:'Please confirm your order with staff',
      notBusinessHours:'Not business hours now, hope to serve you again',
      // Additional UI translations
      poweredBy:'Powered by',
      consumption:'Consumption',
      serviceCharge:'Service Charge',
      totalDiscount:'Total Discount',
      subtotal:'Subtotal',
      grandTotal:'Grand Total',
      phoneNumber:'Phone Number',
      address:'Address',
      telephone:'Telephone',
      enterContactInfo:'Please enter your contact information',
      orderNumber:'Order Number',
      paymentSuccessful:'Payment Successful',
      clickToRepay:'Click to repay',
      onlinePayment:'Online Payment',
      // Button and action text
      nextStep:'Next Step',
      goBack:'Go Back',
      backToPrevious:'Back to Previous',
      submitOrder:'Submit Order',
      orderDeadline:'Order Deadline',
      orderTimeExpired:'Order time has expired',
      pleaseCompleteBy:'Please complete order by',
      extraAdditions:'Extra Additions',
      setPrice:'Set Price',
      takeawayDiscount:'Takeaway Discount',
      price:'Price',
      modifyOptions:'Modify Options',
      delete:'Delete',
      submitOrderBtn:'Submit Order',
      submittingOrder:'Submitting Order...',
      // Form fields
      customerName:'How to address you (Optional)',
      remarks:'Remarks',
      discount:'Discount',
      required:'Required',
      language:'Language',
      tableNumber:'Table Number',
      orderingTimeUntil:'Ordering time until',
      clickToStart:'Click to start ordering',
      scanQRCode:'Please scan QR code or refresh page',
      remove:'Remove',
    },
    zh:{
      takeAway:'外賣自取',
      menu:'精選菜單',
      orderHistory:'落單紀錄',
      contact:'聯絡我們',
      submitOrder:'準備落單',
      tableNumber:'號枱',
      optionTags:'自選口味',
      setTags:'套餐選擇',
      items:'項目',
      soldOut:'售罄',
      // Additional UI text
      cart:'購物車',
      addToCart:'加入購物車',
      goBack:'回上一頁',
      welcome:'歡迎光臨',
      latestOffers:'最新優惠',
      free:'免費',
      quantity:'數量',
      total:'總計',
      checkout:'結帳',
      emptyCart:'購物車是空的',
      close:'關閉',
      confirm:'確認',
      cancel:'取消',
      selectMinimum:'請選最少{{count}}項',
      orderCompleted:'你的點餐已送出',
      pleaseWait:'請耐心等候',
      orderCheckedOut:'訂單已結帳,希望可以再為你服務',
      networkError:'剛才發生網路連接問題',
      confirmWithStaff:'請向服務員確認閣下之點餐',
      notBusinessHours:'現在已非營業時間,希望可以再為你服務',
      // Additional UI translations
      poweredBy:'技術支援',
      consumption:'消費',
      serviceCharge:'服務費',
      totalDiscount:'總折扣',
      subtotal:'小計',
      grandTotal:'全部總計',
      phoneNumber:'電話號碼',
      address:'地址',
      telephone:'電話',
      enterContactInfo:'請輸入你的聯絡資料',
      orderNumber:'外賣單號',
      paymentSuccessful:'已成功網上付款',
      clickToRepay:'按此重新付款',
      onlinePayment:'並網上付款',
      // Button and action text
      nextStep:'下一步',
      goBack:'回上一頁',
      backToPrevious:'回上一項',
      submitOrder:'落單',
      orderDeadline:'落單時限',
      orderTimeExpired:'落單時限已過',
      pleaseCompleteBy:'請於',
      beforeComplete:'前完成落單',
      extraAdditions:'額外添加',
      setPrice:'套餐價',
      takeawayDiscount:'外賣折扣',
      price:'價錢',
      modifyOptions:'修改選項',
      delete:'刪除',
      submitOrderBtn:'送出訂單',
      submittingOrder:'訂單送出中...',
      // Form fields
      customerName:'如何稱呼你 (選填)',
      remarks:'備註',
      discount:'折扣',
      required:'必選',
      language:'語言',
      tableNumber:'枱號',
      orderingTimeUntil:'點餐時間到',
      clickToStart:'按此開始點餐',
      scanQRCode:'請掃描二維碼或重新整理頁面',
      remove:'移除',
    },
    jp:{
      takeAway:'テイクアウト',
      menu:'メニュー',
      orderHistory:'注文履歴',
      contact:'お問い合わせ',
      submitOrder:'注文する',
      tableNumber:'テーブル番号',
      optionTags:'オプション',
      setTags:'セット選択',
      items:'商品',
      soldOut:'売り切れ',
      // Additional UI text
      cart:'カート',
      addToCart:'カートに追加',
      goBack:'戻る',
      welcome:'いらっしゃいませ',
      latestOffers:'最新のお得情報',
      free:'無料',
      quantity:'数量',
      total:'合計',
      checkout:'チェックアウト',
      emptyCart:'カートは空です',
      close:'閉じる',
      confirm:'確認',
      cancel:'キャンセル',
      selectMinimum:'最低{{count}}項目選択してください',
      orderCompleted:'ご注文を承りました',
      pleaseWait:'しばらくお待ちください',
      orderCheckedOut:'ご注文は既にお会計済みです。またのご利用をお待ちしております',
      networkError:'ネットワーク接続に問題が発生しました',
      confirmWithStaff:'スタッフにご注文をご確認ください',
      notBusinessHours:'現在営業時間外です。またのご利用をお待ちしております',
      // Additional UI translations
      poweredBy:'技術提供',
      consumption:'消費',
      serviceCharge:'サービス料',
      totalDiscount:'総割引',
      subtotal:'小計',
      grandTotal:'総合計',
      phoneNumber:'電話番号',
      address:'住所',
      telephone:'電話',
      enterContactInfo:'連絡先情報を入力してください',
      orderNumber:'注文番号',
      paymentSuccessful:'オンライン決済が完了しました',
      clickToRepay:'再決済はこちら',
      onlinePayment:'オンライン決済',
      // Button and action text
      nextStep:'次のステップ',
      goBack:'戻る',
      backToPrevious:'前の項目に戻る',
      submitOrder:'注文する',
      orderDeadline:'注文期限',
      orderTimeExpired:'注文時間が終了しました',
      pleaseCompleteBy:'までに',
      beforeComplete:'注文を完了してください',
      extraAdditions:'追加オプション',
      setPrice:'セット価格',
      takeawayDiscount:'テイクアウト割引',
      price:'価格',
      modifyOptions:'オプション変更',
      delete:'削除',
      submitOrderBtn:'注文を送信',
      submittingOrder:'注文送信中...',
      // Form fields
      customerName:'お名前 (任意)',
      remarks:'備考',
      discount:'割引',
      required:'必須',
      language:'言語',
      tableNumber:'テーブル番号',
      orderingTimeUntil:'注文受付時間',
      clickToStart:'こちらをクリックして注文開始',
      scanQRCode:'QRコードをスキャンするかページを更新してください',
      remove:'削除',
    },
    server: process.env.VUE_APP_SERVER_URL,
    imgServer : process.env.VUE_APP_IMG_SERVER_URL,
    modalVisible: false,
    modalTitle: '',
    modalContent: '',
    clientId: '',
    tableNumber: '',
    orderHistory: [],
    restaurantOrderHistory: [],
    hash: '',
    drawer: false,
    mode: '',
    takeAwayMenuTab: null,
    company: {
      name_en: '',
      name_zh: '',
      name_jp: '',
    },
    shop: {
      id: '',
      name_en: '',
      name_zh: '',
      name_jp: '',
      vertical: '',
      image:'',
      slug:'',
      address_line_1_en:'',
      address_line_2_en:'',
      address_line_3_en:'',
      address_line_1_zh:'',
      address_line_2_zh:'',
      address_line_3_zh:'',
      address_line_1_jp:'',
      address_line_2_jp:'',
      address_line_3_jp:'',
      color_theme:'',
    },
    menu:{
      //service_charge_percentage:0,
    },
    currentSet: {},
    currentItem: {},
    addToCartItem:{},
    currentSetOptionItem: {},
    currentOptions: [],
    cart: [],
    cartItemTotal: 0,
    cartTotal:0,
    soldOutProduct:[],
    soldOutOption:[],
    posOnlyProduct:[],
    open: true,
    paymentPending:false,
    orderTotal:0,
    takeawayDiscountPercentage:0,
  }
}
const state = getDefaultState()


export const store =  new Vuex.Store({
  plugins: [createPersistedState(
    {
      overwrite:true,
      storage: {

        getItem: (key) => {

          console.time('decompress_menu')
          let menu_str =  LZString.decompressFromBase64(window.localStorage.getItem('menu'));
          console.log('menu_str: ',menu_str)

          let menu_obj ={}
          if(menu_str){

            try {
              menu_obj = JSON.parse(menu_str)
            } catch (e) {

              window.localStorage.removeItem('menu')
              location.reload()
            }

            
          }
          console.timeEnd('decompress_menu')
          
          let value_str =''
          value_str = window.localStorage.getItem(key);
          let value={}
          if(value_str){
            try {
                value = JSON.parse(value_str)
            } catch (e) {
                
            }
          }else{
            value = getDefaultState()
          }
          

          if(value){
            value.menu={}
            Object.assign(value.menu, menu_obj)
          }

          return JSON.stringify(value);

        },
        setItem: (key, value) => {

          let val = JSON.parse(value)
          delete val.menu
          let valstr =JSON.stringify(val)
          return window.localStorage.setItem(key, valstr)


        },
        removeItem: (key) => window.localStorage.removeItem(key),
      },
    }
  )],
  
  mutations: {
    setDebounceCode(state, code){
      state.debounceCode = code
    },
    restoreState(state){
      localforage.getItem('menu').then(function(value) {
          // This code runs once the value has been loaded
          // from the offline store.
          Object.assign(state.menu, JSON.parse(value))
          console.log('restore menu');
      }).catch(function(err) {
          // This code runs if there were any errors
          console.log(err);
      });

      localforage.getItem('shop').then(function(value) {
        // This code runs once the value has been loaded
        // from the offline store.
          Object.assign(state.shop, JSON.parse(value))
          console.log('restore shop');
      }).catch(function(err) {
          // This code runs if there were any errors
          console.log(err);
      });
    },

    resetState (state) {
      console.log('resetState()')
      window.localStorage.removeItem('vuex')
      window.localStorage.removeItem('menu')
      Object.assign(state, getDefaultState())
      
    },
    setLocale (state, data){
      state.locale=data;
    },
    cart_item_change(state, item) {

      var target = null;
      //if the element added before

      if (item.cartIndex>=0){
        target = item.cartIndex
      }

      // state.cart.forEach(function (element, index, item) {
      //   console.log(item)
      //   if (element.id == item.id && item.cart_index == index) {
      //     target = index
      //   }
      // })

      if (target == null) {
        //item not existing in cart yet
        new_item = JSON.parse(JSON.stringify(item))
        state.cart.push(new_item)
        
      } else {

        //same item added to cart before, just update the quantity
        state.cart[target].quantity +=  parseInt(item.quantity_change)
        var new_item = JSON.parse(JSON.stringify(state.cart[target]))

        if (new_item.quantity > 0) {
          //replace the item to triger reactive
          Vue.set(state.cart, target, new_item);
          
        } else {
          state.cart.splice(target, 1);
          
        }

      }

      

    },
    remove_item(state, index){
      state.cart.splice(index,1);
    }, 
    add_cart_item_qty(state, index){
      state.cart[index].quantity += 1;
    },
    add_set(state, item) {

      if(!item.quantity ){
        item.quantity = 1;
      }
      

      var new_item = JSON.parse(JSON.stringify(item));
      console.log(new_item)
      if (new_item.cartIndex >= 0) {
        //it is an edit case
        state.cart.splice(new_item.cartIndex, 1, new_item);
      } else {
        //add a new 
        state.cart.push(new_item);
      }
      state.currentSet = {};

    },
    setDrawer(state, newValue) {
      state.drawer = newValue;
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    hideModal(state) {
      state.modalVisible = false;
    },
    showModal(state) {
      state.modalVisible = true;
    },
    hideModal(state) {
      state.modalVisible = false;
    },
    setModalTitle(state,value){
      state.modalTitle = value;
    },
    setModalContent(state,value){
      state.modalContent= value;
    },
    setModalButton(state,value){
      state.modalButton= value;
    },
    setLandingMessageRead(state,value){
      state.landingMessageRead= value;
    },
    setTableInfo(state, tableInfo) {
      //localStorage.clear();


      state.orderTypeId = 1;
      state.orderingEnd = tableInfo.orderingEnd;
      state.tableOccupyEnd = tableInfo.tableOccupyEnd;
      //console.log('tab info',tableInfo)

      state.company.id = tableInfo.company.id;
      state.company.name_en = tableInfo.company.name_en;
      state.company.name_zh = tableInfo.company.name_zh;
      state.company.name_jp = tableInfo.company.name_jp || '';
      

      state.shop.id = tableInfo.shop.id;
      state.shop.name_en = tableInfo.shop.name_en;
      state.shop.name_zh = tableInfo.shop.name_zh;
      state.shop.name_jp = tableInfo.shop.name_jp || '';
      state.shop.slug = tableInfo.shop.slug;
      state.shop.vertical = tableInfo.shop.vertical;
      state.shop.image = tableInfo.shop.image;

      state.shop.ga_code = tableInfo.shop.ga_code;
      state.shop.gtm_code = tableInfo.shop.gtm_code;
      state.shop.fbp_code = tableInfo.shop.fbp_code;

      state.shop.address_line_1_en = tableInfo.shop.address_line_1_en;
      state.shop.address_line_2_en = tableInfo.shop.address_line_2_en;
      state.shop.address_line_3_en = tableInfo.shop.address_line_3_en;

      state.shop.address_line_1_zh = tableInfo.shop.address_line_1_zh;
      state.shop.address_line_2_zh = tableInfo.shop.address_line_2_zh;
      state.shop.address_line_3_zh = tableInfo.shop.address_line_3_zh;

      state.shop.address_line_1_jp = tableInfo.shop.address_line_1_jp || '';
      state.shop.address_line_2_jp = tableInfo.shop.address_line_2_jp || '';
      state.shop.address_line_3_jp = tableInfo.shop.address_line_3_jp || '';

      state.shop.color_theme = tableInfo.shop.color_theme;
      state.restaurantSlug = tableInfo.shop.slug;
      state.tableNumber = tableInfo.tableNumber;
      //
    },
    setRestaurantInfo(state, RestaurantInfo) {
      state.shop = RestaurantInfo;
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setOrderType(state, id) {
      state.orderTypeId = id;
    },
    setHash(state, hash) {
      state.hash = hash;
    },
    setStaticHash(state, hash) {
      state.statichash = hash;
    },
    setRestaurantSlug(state, slug) {
      state.restaurantSlug = slug;
    },

    fetchLocalStorage(state) {

      // if(localStorage.orderTypeId>0){
      //   state.orderTypeId = localStorage.orderTypeId;

      //   state.shop = JSON.parse(localStorage.shop);
      //   state.mode = localStorage.mode;
      //   state.hash = localStorage.hash;
  
  
      //   if (state.orderTypeId == 1) {
      //     state.company = JSON.parse(localStorage.company);
      //     state.tableNumber = localStorage.tableNumber;
      //   }
      // }


    },
    setOrderHistory(state, history) {
      state.orderHistory = history;
    },
    setRestaurantOrderHistory(state, history) {
      state.restaurantOrderHistory = history;
    },
    emptyCart(state) {
      state.cart = [];
      state.cartItemTotal=0;
      state.cartTotal=0;
    },
    emptyCartAndMenu(state) {
      state.cart = [];

      for (var i = 0; i < state.menu.pages.length; i++) {
        for (var j = 0; j < state.menu.pages[i].items.length; j++) {
          state.menu.pages[i].items[j].quantity = 0;
        }
      }

      state.cartItemTotal=0;
      state.cartTotal=0;
    },
    setCurrentSet(state, item) {
      var new_item = JSON.parse(JSON.stringify(item));
      state.currentSet = new_item;
    },
    updateCurrentSet(state) {
      //must do all extra cost calculation in this fucntion, then the cart function can do later
      
      //this is the outer most extraCost
      state.currentSet.extraCost= 0;


      state.currentSet.setItems.forEach(element => {
        
        if(element.type=="item-group"){
          element.extraCost=0;
          element.items.forEach(item => {
            if(element.selected == item.id){

              if(item.type=='options'){
                if(parseFloat(item.extraCost)>0){
                  element.extraCost = parseFloat(item.extraCost)
                  //state.currentSet.extraCost= parseFloat(state.currentSet.extraCost)+parseFloat(item.extraCost)
                  //console.log(item)
                  console.log('set item extra cost')
                }

                if(parseFloat(item.price)>0){
                  element.extraCost=element.extraCost+parseFloat(item.price)
                }
                
                console.log('set Set Item extraCost (options): '+parseFloat(item.extraCost))
              }else{
                element.extraCost = parseFloat(item.price)
                //state.currentSet.extraCost= parseFloat(state.currentSet.extraCost)+parseFloat(item.price);
                console.log('set Set Item extraCost (item-group): '+parseFloat(item.price))
              }
              
              
            }
          });

          state.currentSet.extraCost= parseFloat(state.currentSet.extraCost)+ parseFloat(element.extraCost) ;
          
        }else if(element.type=="option-group"){
          element.extraCost=0;

          element.items.forEach(optionGroup => {

            if(optionGroup.option_group_type_id ==1||optionGroup.option_group_type_id ==4){
              optionGroup.items.forEach(option => {
              
                if(optionGroup.selected==option.id&&parseInt(option.price)>0){
                  console.log(option.name_en);
                  
                  element.extraCost = element.extraCost+ parseInt(option.price);
                  console.log('set Set Item extraCost (option-group): '+parseFloat(element.extraCost))
                  state.currentSet.extraCost = state.currentSet.extraCost+ parseInt(option.price);
                }
              });

            }
            if(optionGroup.option_group_type_id ==2){
              optionGroup.items.forEach(option => {
              
                if(option.selected&&parseInt(option.price)>0){
                  
                  element.extraCost = element.extraCost+ parseInt(option.price);
                  console.log('set Set Item extraCost (option-group): '+parseFloat(element.extraCost))
                  state.currentSet.extraCost = state.currentSet.extraCost+ parseInt(option.price);
                }else if(option.quantity>0){
                  element.extraCost = element.extraCost+ parseInt(option.price)*parseInt(option.quantity);
                  console.log('set Set Item extraCost (option-group add-on qty): '+parseFloat(element.extraCost))
                  state.currentSet.extraCost = state.currentSet.extraCost+ parseInt(option.price)*parseInt(option.quantity);
                }
              });
            }


          });

          // state.currentSet.extraCost= parseInt(state.currentSet.extraCost)+ parseInt(element.extraCost) ;
        }
        
      });

      console.log(state.currentSet.extraCost);
    },

    setCurrentItem(state, item) {
      var new_item = JSON.parse(JSON.stringify(item));
      state.currentItem = new_item;
    },
    setAddToCartItem(state, item) {
      var new_item = JSON.parse(JSON.stringify(item));
      state.addToCartItem = new_item;
    },
    clearCurrentItem(state) {
      state.currentItem = {};
    },
    setCuttentSetOptionItem(state, item) {
      state.currentSetOptionItem = item;
    },
    setCurrentOptions(state, item) {
      state.currentOptions = item;
    },
    setTakeAwayMenuTab(state, tab) {
      state.takeAwayMenuTab = tab;
    },
    jumpHistory() {
      router.push({
        path: '/orderHistory'
      });
    },

    jumpTakeAwayMenu() {
      router.push({
        path: '/TakeAwayMenu'
      });
    },

    updateCartTotal(state) {

      function optionExtraCost(item){
        var extraCost = 0;
        if(item.optionGroups.length>0){
          for(var i =0 ; i < item.optionGroups.length; i++){
            if(item.optionGroups[i].extraCost>0){
              extraCost+= parseInt(item.optionGroups[i].extraCost);
            }
          }
        }
        return extraCost;
      }

      function addOnExtraCost(item){
        var extraCost = 0;
        if(item.addOnGroups.length>0){
          for(var i =0 ; i < item.addOnGroups.length; i++){
            for(var j =0 ;j <item.addOnGroups[i].addOns.length; j++){
              if (typeof item.addOnGroups[i].addOns[j].selected !== 'undefined' && item.addOnGroups[i].addOns[j].selected){
                if (item.addOnGroups[i].addOns[j].price>0){

                  extraCost += parseInt(item.addOnGroups[i].addOns[j].price)
                }
              }else if(item.addOnGroups[i].addOns[j].quantity >0){
                if (item.addOnGroups[i].addOns[j].price>0){

                  extraCost += parseInt(item.addOnGroups[i].addOns[j].price*item.addOnGroups[i].addOns[j].quantity)
                }
              }
            }
          }
        }

        
        return extraCost;
      }

      function choiceExtraCost(item){
        var extraCost = 0;
        if(item.hasOwnProperty('choiceGroups')&&item.choiceGroups.length>0){
          for(var i =0 ; i < item.choiceGroups.length; i++){
            for(var j =0 ;j <item.choiceGroups[i].choices.length; j++){
              extraCost += item.choiceGroups[i].choices[j].quantity*item.choiceGroups[i].choices[j].price
            }
          }
        }
        return extraCost;
      }




      state.cartItemTotal = 0;

      state.cart.forEach(function (item) {
        if (item.type == 'set') {
          //assuming the calsulation is ready
          state.cartItemTotal = state.cartItemTotal + (item.price * item.quantity)+ (item.extraCost * item.quantity);
          // item.setItems.forEach(function (setItem) {
          //   if (setItem.type == 'option-group') {
          //     setItem.items.forEach(function (option) {
          //       state.cartItemTotal = state.cartItemTotal + parseInt(option.extraCost);
          //     });
          //   } else {
          //     state.cartItemTotal = state.cartItemTotal + parseInt(setItem.extraCost);
          //   }
          // });

        } else if (item.type == 'options') {


          var extraCost =0;
          extraCost += optionExtraCost(item);
          extraCost += addOnExtraCost(item);
          extraCost += choiceExtraCost(item);

          //alert(extraCost);
          state.cartItemTotal = state.cartItemTotal + ((parseInt(item.price) + parseInt(extraCost)) * item.quantity);
          
        } else {
          state.cartItemTotal = state.cartItemTotal + (item.price * item.quantity);
        }

      });

      if(state.menu.service_charge_percentage>0){
        state.cartTotal = state.cartItemTotal + (state.cartItemTotal*state.menu.service_charge_percentage/100)
      }else{
        state.cartTotal = state.cartItemTotal;
        console.log('update cart total')
      }

      if(state.takeawayDiscountPercentage>0){
        state.cartTotal = Math.round(state.cartTotal - (state.cartTotal*state.takeawayDiscountPercentage/100))
      }else{
        state.cartTotal = state.cartItemTotal;
        console.log('update cart total')
      }


    },
    setRestaurantMenu(state, data) {
      //console.log('compressed_menu_data: ',data)
      console.time('decompress_menu_and_parse_json')
      var menu = JSON.parse(LZString.decompressFromBase64(data))
      console.timeEnd('decompress_menu_and_parse_json')

      Object.assign(state.menu , menu)

      // let str = JSON.stringify(data);
      // console.time('compress_menu')
      // str= LZString.compress(str);
      // console.timeEnd('compress_menu')
      window.localStorage.setItem('menu', data)

      // localforage.setItem('menu', JSON.stringify(data)).then(function(){
      //   console.log('store menu')
      // });

      // localforage.setItem('shop', JSON.stringify(state.shop)).then(function(){
      //   console.log('store shop')
      // });
      state.menu = menu
    },
    setMobileNumber(state, data) {
      state.mobileNumber = data
    },
    setOrderRemark(state, data) {
      state.orderRemark = data
    },

    setCustomerName(state, data) {
      state.customerName = data
    },

    syncMenuQuabtity(state, id){

      var quantity = 0;
      for (var k = 0; k < state.cart.length; k++){
        quantity = state.cart[k].quantity;
      }


      for (var i = 0; i < state.menu.pages.length; i++) {
        for (var j = 0; j < state.menu.pages[i].items.length; j++) {
          if(state.menu.pages[i].items[j].id==id){
            state.menu.pages[i].items[j].quantity = quantity;
          }
        }
      }
    },
    setSoldOutProduct(state,data){

      state.soldOutProduct = data;
    },
    setSoldOutOption(state,data){

      state.soldOutOption = data;
    },
    setPosOnlyProduct(state,data){
      state.posOnlyProduct = data;
    },
    setServiceChargePercentage(state,data){
      state.serviceChargePercentage = data;
    },
    setTakeawayDiscountPercentage(state,data){
      state.takeawayDiscountPercentage = data;
    },
    setPaymentPending(state,data){
      state.paymentPending = data;
    },
    setOrderTotal(state,data){
      state.orderTotal = data;
    },
    setRestaurantList(state,data){
      state.restaurantList = data;
    },
    initPixel(state,data){
      if(state.shop.fbp_code){
        var img = document.createElement("img"); 
        img.src = "https://www.facebook.com/tr?id="+state.shop.fbp_code+"&ev=PageView&noscript=1"; 
        img.width = 1;
        img.height = 1;
        img.cssText = 'display:none';
        document.body.appendChild(img);  
        fbq('init', state.shop.fbp_code);
        fbq('track', 'PageView');
        fbq('track', 'MenuHome');
      }
    },
    initGA(){
      if(state.shop.ga_code){
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', ga_code);
      }
    }

  },
  actions: {
    add_item(context, item) {
      //for dim sum use only
      item.quantity_change = item.quantity
      context.commit('cart_item_change', item);
      context.commit('updateCartTotal');

    },
    sub_item(context, item) {
      item.quantity_change = -1
      context.commit('cart_item_change', item);
      context.commit('updateCartTotal');

    },
    remove_item(context, index){
      context.commit('remove_item', index);
      context.commit('updateCartTotal');
      console.log('updateCartTotal after remove_item');
    },
    add_item_to_cart(context, item){
      item.quantity_change = item.quantity;
      context.commit('cart_item_change', item);
      context.commit('updateCartTotal');
    },
    add_cart_item_qty(context, index){
      context.commit('add_cart_item_qty', index);
      context.commit('updateCartTotal');
    },
    add_set_item(context, item) {
      context.commit('add_set', item);
    },
    addCurrentItemToCart({
      commit,
      state
    }) {
      commit('add_set', state.currentItem);
      commit('updateCartTotal');
    },
    submitCart({
      commit,
      state
    }) {

      if(state.debouncing){
        console.log('debounced')
        return false;
      }else{
        state.debouncing = true;

        if(state.cart.length==0){
          return false;
        }

        api.post('/api/addOrderBatch', {
            company_id: state.company.id,
            shop_id: state.shop.id,
            menu_id:state.menu.id,
            cart: state.cart,
            hash: state.hash,
            order_type_id: state.orderTypeId,
            mobile_number: state.mobileNumber,
            customer_name: state.customerName,
            order_remark: state.orderRemark,
            debounceCode:state.debounceCode,
  
          }).then(response => {
            state.debouncing = false;
            if (response.data.result == 'success') {
              commit('setDebounceCode', response.data.data.debounceCode);

              commit('setModalTitle', state[state.locale].orderCompleted);
              commit('setModalContent', state[state.locale].pleaseWait);
              commit('setModalButton', 'OK');
              commit('showModal', state);
              commit('emptyCart', state);
              if(response.data.data.checkoutUrl){
                console.log('jumping gateway')
                window.location.href = response.data.data.checkoutUrl;
              }
              commit('jumpHistory', state);
            }else if(response.data.result == 'fail' && response.data.message == 'order checked out'){
              router.push('/table/'+state.hash) 
              commit('setModalTitle', state[state.locale].welcome);
              commit('setModalContent', state[state.locale].orderCheckedOut);
              commit('setModalButton', 'none');
              commit('showModal', 'none');
              
            }else if(response.data.result == 'fail' && response.data.message == 'debounce failed'){
              console.log('debounce code failed.')
              commit('setDebounceCode', response.data.data.debounceCode);
              commit('setModalTitle', state[state.locale].networkError);
              commit('setModalContent', state[state.locale].confirmWithStaff);
              commit('setModalButton', 'OK');
              commit('showModal', state);
              commit('emptyCart', state);
              commit('jumpHistory', state);
            }
          })
          .catch(e => {
            state.debouncing = false;
            //console.log(e)
            //this.errors.push(e)
          })
      }

    },
    getTableByHash({
      commit,
      state
    }) {

      api.post('/api/getTableByHash', {
          hash: state.hash,
        }).then(response => {
          if (response.data.result == 'success') {
            
            commit('setTableInfo', response.data.tableInfo);
            commit('setMode', 'normal');
            commit('hideModal');

            if(response.data.paymentPending==true){
              commit('setOrderTotal',response.data.orderTotal);
              commit('setPaymentPending',response.data.paymentPending);
              commit('setOrderTotal',response.data.orderTotal);
              router.push({
                path: '/orderHistory'
              });
            }
            commit('initPixel');
            commit('initGA');
            
            
          }else if(response.data.result == 'fail' && response.data.message == 'order checked out'){

            commit('setModalTitle', '歡迎光臨');
            commit('setModalContent', '訂單已結帳,希望可以再為你服務。');
            commit('setModalButton', 'none');
            commit('showModal');
          }
        })
        .catch(e => {
          this.errors.push(e)
        })
        //Vue.$forceUpdate(); 
    },
    getTableByStaticHash({
      commit,
      state
    }) {

      api.post('/api/getTableByStaticHash', {
          hash: state.statichash,
        }).then(response => {
          if (response.data.result == 'success') {
            
            commit('setTableInfo', response.data.tableInfo);
            commit('setMode', 'normal');
            commit('hideModal');
            commit('setHash',response.data.orderHash);
            if(response.data.paymentPending==true){
              
              commit('setOrderTotal',response.data.orderTotal);
              commit('setPaymentPending',response.data.paymentPending);
              commit('setOrderTotal',response.data.orderTotal);
              router.push({
                path: '/orderHistory'
              });
            }
            commit('initPixel');
            commit('initGA');
            
            
          }else if(response.data.result == 'fail' && response.data.message == 'order checked out'){

            commit('setModalTitle', '歡迎光臨');
            commit('setModalContent', '訂單已結帳,希望可以再為你服務。');
            commit('setModalButton', 'none');
            commit('showModal');
          }
        })
        .catch(e => {
          this.errors.push(e)
        })
        //Vue.$forceUpdate(); 
    },
    getRestaurantMenu({
      commit,
      state
    }) {
      // this is a netural method now, do not set order type
      api.post(process.env.VUE_APP_SERVER_URL + 'api/getRestaurantMenu', {
          shop_slug: state.restaurantSlug,
          menu_type_id: state.orderTypeId,
          hash: state.hash,
        }).then(response => {
          if(response.data.open==false){
            alert('QR Menu not available.');
            commit('setModalTitle', state[state.locale].welcome);
            commit('setModalContent', state[state.locale].notBusinessHours);
            commit('setModalButton', 'none');
            commit('showModal');
            router.push({
              path: '/table/'+state.hash,
            });

            return 0;
          }
          commit('setRestaurantInfo', response.data.shop);
          commit('setSoldOutProduct', response.data.soldOutProduct);
          commit('setSoldOutOption', response.data.soldOutOption);
          commit('setPosOnlyProduct', response.data.posOnlyProduct);
          commit('setServiceChargePercentage', response.data.service_charge_percentage);
          commit('setTakeawayDiscountPercentage', response.data.takeaway_discount);
          commit('setRestaurantMenu', response.data.menu_data_compressed);
          commit('setDebounceCode',response.data.debounceCode);
          //location.reload();
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    getOrderHistory({
      commit,
      state
    }) {


      if(state.orderTypeId ==1){
        api.post(process.env.VUE_APP_SERVER_URL + 'api/orderHistory', {
          order_type_id :1,
          hash: state.hash,
        }).then(response => {
          commit('setOrderHistory', response.data);
        })
        .catch(e => {
          //this.errors.push(e)
        })
      }else if(state.orderTypeId ==2){
        axios.post(process.env.VUE_APP_SERVER_URL + 'api/orderHistory', {
          order_type_id :2,
          mobile_number: state.mobileNumber,
          shop_id :state.shop.id,
        }).then(response => {
          commit('setOrderHistory', response.data);
        })
        .catch(e => {
          //this.errors.push(e)
        })
      }

    },
    getSoldOutProduct({
      commit,
      state
    }){
      axios.post(process.env.VUE_APP_SERVER_URL + 'api/getSoldOutProduct', {
        shop_id :state.shop.id,
      }).then(response => {
        commit('setSoldOutProduct', response.data);
      })
      .catch(e => {
        //this.errors.push(e)
      })
    },
    getSoldOutOption({
      commit,
      state
    }){
      axios.post(process.env.VUE_APP_SERVER_URL + 'api/getSoldOutOption', {
        shop_id :state.shop.id,
      }).then(response => {
        commit('setSoldOutOption', response.data);
      })
      .catch(e => {
        //this.errors.push(e)
      })
    },
    getPosOnlyProuct({
      commit,
      state
    }){
      axios.post(process.env.VUE_APP_SERVER_URL + 'api/getPosOnlyProuct', {
        shop_id :state.shop.id,
      }).then(response => {
        commit('setPosOnlyProuct', response.data);
      })
      .catch(e => {
        //this.errors.push(e)
      })
    },

    getRestaurant({
      commit,
      state
    }) {
      api.post(process.env.VUE_APP_SERVER_URL + 'api/getRestaurant', {
          restaurantSlug: state.restaurantSlug,
        }).then(response => {
          commit('setRestaurantInfo', response.data);
          commit('setMode', 'takeAway');
          router.push({
            path: '/TakeAwayMenu'
          });
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getRestaurantOrderHistory({
      commit,
      state
    }) {
      api.post(process.env.VUE_APP_SERVER_URL + 'api/orderHistory', {
          hash: state.hash,
        }).then(response => {
          commit('setRestaurantOrderHistory', response.data);
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    getRestaurantList({
      commit,
      state
    }) {
      api.post(process.env.VUE_APP_SERVER_URL + 'api/getRestaurantList', {
          hash: '',
        }).then(response => {
          commit('setRestaurantList', response.data);
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

  }


})